'use strict';

var FormControl$1 = require('./src/FormControl.js');
var HelperText = require('./src/HelperText.js');

const FormControl = FormControl$1.FormControl;
FormControl.HelperText = HelperText.default;

exports.FormControl = FormControl;
//# sourceMappingURL=index.js.map
